import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { sendEmailVerification } from "firebase/auth";
import { Button } from "antd";

import { auth } from "../../config/firebase/firebase";
import routeNames from "constants/route-names";
import { useAuth } from "context/AuthContext";
import SimpleLoginLayout from "components/layouts/simple-login-layout/simple-login-layout";

const RESEND_COOLDOWN_SECONDS = 60; // 1 minute

const EmailVerification = () => {
	const navigate = useNavigate();
	const { loggedUser } = useAuth();
	const [countdown, setCountdown] = useState(RESEND_COOLDOWN_SECONDS);
	const [isResendDisabled, setIsResendDisabled] = useState(true);

	// Check email verification status periodically
	useEffect(() => {
		const checkEmailVerification = setInterval(async () => {
			if (loggedUser) {
				await loggedUser.reload(); // Refresh user data from Firebase
				if (loggedUser.emailVerified) {
					// Email verified! Navigate to dashboard
					navigate(routeNames.DASHBOARD);
				}
			}
		}, 10000); // Check every 10 seconds

		return () => clearInterval(checkEmailVerification);
	}, [loggedUser, navigate]);

	// Timer for resend button cooldown
	useEffect(() => {
		if (countdown <= 0) {
			setIsResendDisabled(false);
			return;
		}

		const timer = setInterval(() => {
			setCountdown(prev => prev - 1);
		}, 1000);

		return () => clearInterval(timer);
	}, [countdown]);

	const handleResendEmail = async () => {
		const user = auth.currentUser;
		console.log("Resending verification email user: ", user);
		if (user) {
			try {
				const baseUrl = window.location.origin;
				const continueUrlParam = `${baseUrl}/dashboard`;

				await sendEmailVerification(user, {
					url: continueUrlParam,
					handleCodeInApp: true
				});

				console.log("Verification email resent");

				// Reset countdown and disable button again
				setCountdown(RESEND_COOLDOWN_SECONDS);
				setIsResendDisabled(true);
			} catch (error) {
				console.error("Error resending verification email:", error);
			}
		}
	};

	return (
		<SimpleLoginLayout>
			<div className="email-verification-card">
				<div>We just sent an email with a link to verify your address.</div>
				<div>Please check your inbox or spam folder.</div>

				<span className="link-label">
					Need assistance?
					<a className="inline-link bold-link" href="mailto:support@highnotes.com?subject=Trouble Signing Up">
						Contact Us
					</a>
				</span>

				<Button className="resend-email" onClick={handleResendEmail} disabled={isResendDisabled}>
					{isResendDisabled ? `Resend verification email (${countdown}s)` : "Resend verification email"}
				</Button>
			</div>
		</SimpleLoginLayout>
	);
};

export default EmailVerification;
